import React from 'react';
import { Check } from 'lucide-react';
import { ACTIONS, RESOURCES, toggleScope } from '../../lib/developerApi';

/**
 * Resources × actions. A cell a resource does not support renders a dash, so
 * "Team members" can only be read and "Timeline events" only created — the
 * same shape as the server's scope registry. Ticking update or delete also
 * ticks read (see `toggleScope`).
 */
export default function ScopeMatrix({ value, onChange, disabled = false }) {
    return (
        <div className="border border-stone-200 rounded-lg overflow-hidden" data-testid="scope-matrix">
            <div className="grid grid-cols-[1.4fr_repeat(4,0.8fr)] items-center bg-stone-50 text-[11px] font-medium tracking-wider uppercase text-stone-500 border-b border-stone-100">
                <span className="px-3 py-2.5">Resource</span>
                {ACTIONS.map((a) => <span key={a} className="px-3 py-2.5 text-center">{a}</span>)}
            </div>
            {RESOURCES.map((resource) => (
                <div key={resource.key} className="grid grid-cols-[1.4fr_repeat(4,0.8fr)] items-center border-b border-stone-100 last:border-b-0">
                    <span className="px-3 py-2.5 text-sm font-medium text-stone-900">
                        {resource.label}
                        {resource.note && <small className="block text-[11.5px] font-normal text-stone-400">{resource.note}</small>}
                    </span>
                    {ACTIONS.map((action) => {
                        if (!resource.actions.includes(action)) {
                            return <span key={action} className="px-3 py-2.5 text-center text-stone-200">—</span>;
                        }
                        const scope = `${resource.key}:${action}`;
                        const on = value.includes(scope);
                        const tone = on ? (action === 'delete' ? 'bg-red-600 border-red-600' : 'bg-stone-900 border-stone-900') : 'bg-white border-stone-400';
                        return (
                            <span key={action} className="px-3 py-2.5 flex justify-center">
                                <button
                                    type="button"
                                    role="checkbox"
                                    aria-checked={on}
                                    aria-label={`${resource.label} ${action}`}
                                    data-scope={scope}
                                    disabled={disabled}
                                    onClick={() => onChange(toggleScope(value, scope))}
                                    className={`w-4 h-4 rounded border inline-flex items-center justify-center text-white disabled:opacity-50 ${tone}`}
                                >
                                    {on && <Check className="w-3 h-3" strokeWidth={3} />}
                                </button>
                            </span>
                        );
                    })}
                </div>
            ))}
        </div>
    );
}
